import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';

export const currentSiteName = (state: RootState) => state.masterSlave?.masterSlave?.CurrentyLoggedClient;
export const currentSiteGuid = (state: RootState) => state.masterSlave?.masterSlave?.CurrentSiteGuid;
export const currentSiteSlaveDetails = (state: RootState) => state.masterSlave?.masterSlave?.SlaveDetails;

export const currentContextSiteSelector = createSelector(
  [currentSiteName, currentSiteGuid, currentSiteSlaveDetails],
  (currentSiteName = '', currentSiteGuid = '', currentSiteSlaveDetails = []) => {
    // fallback for TenantDropdown
    // in old backend currentSiteName is empty string when user is logged in to global ("All") site
    // in old backend currentSiteSlaveDetails does not contain global ("All") site
    if (!currentSiteName) {
      return null;
    }
    if (currentSiteGuid) {
      return currentSiteSlaveDetails.find(({ DbTenantId }: { DbTenantId: string }) => DbTenantId === currentSiteGuid);
    }
    return currentSiteSlaveDetails.find(({ Name }: { Name: string }) => Name === currentSiteName);
  }
);
